import * as yup from 'yup';

import { ValidationError } from 'src/enums/Validation';
import { Organization } from 'src/types/resources/Organization';

const DEFAULT_RATE_VALUE = 20;

export type ChangeRateFormData = Pick<Organization, 'rate'>;
export type ChangeRateFormDataToSubmit = Pick<Organization, 'name' | 'rate'>;

export const validationFields = {
  rate: yup.number().min(0).required(ValidationError.default),
};

export const validationSchema = yup.object(validationFields);

export const initialValues = (organization: Organization): ChangeRateFormData => {
  return {
    rate: organization.rate || organization.rate === 0 ? organization.rate : DEFAULT_RATE_VALUE,
  };
};

export const attributesToSubmit = (values: ChangeRateFormData, name: string): ChangeRateFormDataToSubmit => {
  return { name, ...values };
};
